import React from "react";
import { Box } from "@mui/material";
import useFooterMode from "../hooks/useFooterMode";
import {
  COPYRIGHT_FOOTER_HEIGHT,
  FOOTER_FLOW_GAP,
} from "../helpers/layoutConstants";

const Copyrighttext = () => {
  const mode = useFooterMode(COPYRIGHT_FOOTER_HEIGHT, FOOTER_FLOW_GAP);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: `${COPYRIGHT_FOOTER_HEIGHT}px`,
        backgroundColor: "#f5f9fc",
        flexShrink: 0,
        ...(mode === "fixed"
          ? { position: "fixed", bottom: 0, left: 0, zIndex: 9 }
          : // Flow-mode gap between the page content and the copyright —
            // the fixed onboarding stepper lands inside it at full scroll.
            { marginTop: `${FOOTER_FLOW_GAP}px` }),
        fontSize: {
          xs: "12px",
          sm: "12px",
          md: "14px",
          lg: "16px",
        },
      }}
    >
      Copyright © 2024 Elevate Aviation. All rights reserved.
    </Box>
  );
};
export default Copyrighttext;
